import smetaAxios from "../../../SmetaAxios";
import { Prefixes } from "../../Tools/ProjectX";
import { createGrid, createRecordSource } from "../rcsgrid";

const reserveTabNumberHandler = (free: boolean, id: string) => {
  smetaAxios.get("ReserveTabNumber", {
    prefix: Prefixes.person,
    params: { Free: Number(free), ID: id },
    loadMask: true,
  });
};

export async function personsGrid(grid: createGrid, source: createRecordSource, props, data) {
  let reserveTabNumber = "";
  if (data.setSelectedRecord) {
    source.onRecordIndexChanged = (source) => {
      data.setSelectedRecord(source.getFieldTextSync("ID"));
    };
  }
  grid.CommitToSaveChanges = (data: createGrid | boolean) => {
    if (typeof data !== "boolean") {
      if (!data.editorMode()) {
        reserveTabNumber = data.source.getFieldValueSync("TabNum");
        reserveTabNumberHandler(false, reserveTabNumber);
      }
    } else if (reserveTabNumber) {
      reserveTabNumberHandler(true, reserveTabNumber);
      reserveTabNumber = "";
    }
  };
}
